import { FunctionComponent, useEffect } from "react";
import { useGetWidgetModel, WidgetModel } from "@sisense/sdk-ui";

export interface GetWidgetModelProps {
  dashboardOid: string;
  widgetOid: string;
  exitComponent: (widgetModel?: WidgetModel | Error) => void;
}

export const GetWidgetModel: FunctionComponent<GetWidgetModelProps> = ({
  dashboardOid,
  widgetOid,
  exitComponent,
}) => {
  const { widget, error } = useGetWidgetModel({ dashboardOid, widgetOid });

  useEffect(() => {
    if (widget || error) {
      exitComponent(widget || error);
    }
  }, [widget, exitComponent, error]);

  return null;
};
